module.exports = __webpack_public_path__ + "img/PRNT_06_mono_AE_00005.01d3f2c9.png";